import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import refundRequest from 'assets/dashboard/refundRequest.png';
import ListRefundRequestDashboard from './listRefundRequest';

export const DOWNTIME_REFUND_RESOURCES = {
	listRefundRequest: 'listRefundRequest'
};

export const URL = {
	[DOWNTIME_REFUND_RESOURCES.listRefundRequest]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.downtimeRefund}/${DOWNTIME_REFUND_RESOURCES.listRefundRequest}`
};

export const LABEL = {
	[DOWNTIME_REFUND_RESOURCES.listRefundRequest]: 'Request List'
};

export const COMPONENT = {
	[DOWNTIME_REFUND_RESOURCES.listRefundRequest]: ListRefundRequestDashboard
};

export const GET_ACTION = {
	[DOWNTIME_REFUND_RESOURCES.listRefundRequest]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.downtimeRefund].listRefundRequest
};

export const IMAGE_SOURCE = {
	[DOWNTIME_REFUND_RESOURCES.listRefundRequest]: refundRequest
};

export enum EDowntimeRefundURL {
	GET_REFUND_REQUEST_STATUS = '/marketing/dashboard/downtimeRefund/getRefundRequestStatus',
	APPROVE_AND_PROCESS_REFUND_REQUEST = '/marketing/dashboard/downtimeRefund/approveAndProcessRefundRequest',
	REJECT_REFUND_REQUEST = '/marketing/dashboard/downtimeRefund/rejectRefundRequest',
	CREATE_REFUND_REQUEST = '/marketing/dashboard/downtimeRefund/createRefundRequest',
	DOWNLOAD_REFUND_REQUEST = '/marketing/dashboard/downtimeRefund/downloadRefundRequest'
}

export enum EResponseCode {
	SUCCESS = 200
}
